import { createSlice } from "@reduxjs/toolkit";


export const commentaireSlice = createSlice({
    name: 'commentaire',
    initialState:{},
    reducers: { //modify the selected spot in global state
        setCommentaire: (currentState, action) => {
            
            return action.payload //action.payload is the new livrasion object (valid, secteur, adresse,comp) sent by the dispatch call

        }
    }
});